export default "__VITE_ASSET__BTesDeIh__"